import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { UserService } from '../services/user.service';
import {
  fetchUserList,
  loadedUserList,
  failedUserList,
  updateUserListFilter,
} from './user-list.actions';
import { selectUserListFilter } from './user-list.selector';

@Injectable()
export class UserListEffect {
  loadUserList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchUserList),
      switchMap(({ filter }) =>
        this.userService.getUserList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedUserList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedUserList();
            }
          }),
          catchError(() => of(failedUserList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateUserListFilter),
      concatLatestFrom(() => this.store.select(selectUserListFilter)),
      switchMap(([action, prevFilter]) =>
        of(fetchUserList({ filter: { ...prevFilter, ...action.filter } }))
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly userService: UserService
  ) {}
}
